import React from 'react'
import './Footer.css'
import { assets } from '../../assets/assets'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Footer = () => {
  const { t } = useTranslation();
  
  return (
    <div className='footer'>
      <div className='footer-wrapper'>
        <div className="footer-content">
          <div className="footer-content-left">
            <h2>DASHBASKET</h2>
            <div className="footer-social-icons">
              <a href="" target="_blank" rel="noopener noreferrer" className="social-icon linkedin" title="LinkedIn">
                <span className="social-text">in</span>
              </a>
              <a href="" target="_blank" rel="noopener noreferrer" className="social-icon facebook" title="Facebook">
                <span className="social-text">f</span>
              </a>
              <a href="" target="_blank" rel="noopener noreferrer" className="social-icon twitter" title="Twitter">
                <span className="social-text">𝕏</span>
              </a>
            </div>
            
            <div className="footer-app-download">
              <img src={assets.play_store} alt={t('footer.google_play_store')} />
              <img src={assets.app_store} alt={t('footer.apple_app_store')} />
            </div>
            
            <p>© 2025 DASHBASKET {t('footer.all_rights_reserved')}</p>
          </div>
          <div className="footer-content-center">
            <h2>{t('footer.links')}</h2>
            <ul>
              <li>{t('footer.about_us')}</li>
              <li>{t('footer.services')}</li>
              <li>{t('footer.contact')}</li>
              <li className="apply-link">
                <Link to="/restaurant-apply">{t('footer.apply_as_restaurant')}</Link>
              </li>
              <li className="apply-link">
                <Link to="/driver-apply">{t('footer.apply_as_driver')}</Link>
              </li>
            </ul>
          </div>
          <div className="footer-content-right">
            <h2>{t('footer.information')}</h2>
            <ul>
              <li>{t('footer.help_center')}</li>
              <li>{t('footer.support')}</li>
              <li>
                <Link to="/terms">{t('footer.terms_of_service')}</Link>
              </li>
              <li>
                <Link to="/privacy">{t('footer.privacy_policy')}</Link>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="footer-copyright">
          <p>{t('footer.powered_by')} DASHBASKET 😎</p>
        </div>
      </div>
    </div>
  )
}

export default Footer
